import { useEffect } from 'react'
import { navigateTo } from '../../utils/navigateTo'

// rootPath/settingsPath are app-provided: where to land the user once setup
// finishes depends on the consuming app's own routes, not this package's.
// onComplete defaults to a full-page navigation (navigateTo); consumers that
// keep their own router (e.g. an Atlas-hosted SPA) should pass a
// router-backed callback instead, so completion doesn't escape their app.
const RegisterMFACompleteStep = ({
  isFromSettings,
  rootPath,
  settingsPath,
  onComplete = navigateTo,
}) => {
  useEffect(() => {
    onComplete(isFromSettings ? settingsPath : rootPath)
  }, [isFromSettings, rootPath, settingsPath, onComplete])

  return null
}

export default RegisterMFACompleteStep
